// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__WGhpZ","text":"styles_text__bP1cO"};